import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { OnChangeParams, Options } from 'baseui/select';
import { ORDER_ASCENDING } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { OrderDirection } from '../../types/app';
import { InlineSelect } from './InlineSelect';
import { StyledTooltip } from './StyledTooltip';

type Props = {
  options: Options;
  value: string;
  onSortChange: (params: OnChangeParams) => void;
  orderDirection: OrderDirection;
  onOrderDirectionClick: () => void;
};

export function SortPicker({ options, value, onSortChange, orderDirection, onOrderDirectionClick }: Props) {
  const { theme } = useStyles();
  const orderAscending = orderDirection === ORDER_ASCENDING;

  return (
    <FlexRow gap={theme.sizing.scale0}>
      <InlineSelect
        label="Ordenar por:"
        options={options}
        value={[{ id: value }]}
        onChange={onSortChange}
      />
      <StyledTooltip
        content={orderAscending ? 'Ascendente' : 'Descendente'}
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onOrderDirectionClick}
          kind="secondary"
        >
          <MaterialIcon name={orderAscending ? 'keyboard_double_arrow_up' : 'keyboard_double_arrow_down'} />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}
